/**
 * @file
 * A JavaScript file containing the view specific functionality
 */

(function (Drupal, $) {
  $(document).ready(function (){
    clickViewFilter();
  });

  function clickViewFilter() {
    var hash = window.location.hash;
    var viewsToClick = [
      '/invest', '/uk/invest', '/us/invest', '/aus/invest', '/eur/invest',
      '/forms', '/uk/forms', '/us/forms', '/aus/forms', '/eur/forms',
      '/performance', '/uk/performance', '/us/performance', '/aus/performance', '/eur/performance'
    ];
    var clickView = viewsToClick.indexOf(window.location.pathname) != -1;
    if (hash && clickView) {
      var option = 'option[data-fund-id="' + hash.slice(1) + '"]';
      $(option).prop('selected',true).trigger('change');
    }
  }

})(Drupal, jQuery);
